import type { StatisticsTabResponse } from '../../types';

export function isStatisticsTabEmpty(data: StatisticsTabResponse): boolean {
  const overviewEmpty = data.overview === null;
  const previousMeetingsEmpty = data.previousMeetings === null;
  const victoryProbabilityEmpty = data.victoryProbability === null;

  const lastFiveGamesEmpty =
    data.lastFiveGames === null ||
    (data.lastFiveGames.homeLastMatches.length === 0 &&
      data.lastFiveGames.awayLastMatches.length === 0);

  const topGoalscorersEmpty =
    data.topGoalscorers === null ||
    (data.topGoalscorers.home.length === 0 && data.topGoalscorers.away.length === 0);

  const seasonStatisticsEmpty = data.seasonStatistics === null;
  const otherInfoEmpty = data.otherInfo === null;

  return (
    overviewEmpty &&
    previousMeetingsEmpty &&
    victoryProbabilityEmpty &&
    lastFiveGamesEmpty &&
    topGoalscorersEmpty &&
    seasonStatisticsEmpty &&
    otherInfoEmpty
  );
}
